export const NODE_COLORS = [
  { key: 'indigo', label: 'Indigo' },
  { key: 'sky', label: 'Sky' },
  { key: 'emerald', label: 'Emerald' },
  { key: 'amber', label: 'Amber' },
  { key: 'rose', label: 'Rose' },
  { key: 'violet', label: 'Violet' },
  { key: 'pink', label: 'Pink' },
  { key: 'slate', label: 'Slate' },
];

export const ROOT_COLOR = 'indigo';

export const BRANCH_COLORS = ['sky', 'emerald', 'amber', 'rose', 'violet', 'pink'];

const KNOWN_COLORS = new Set(NODE_COLORS.map((color) => color.key));

export const colorClass = (color) => `mm-c-${KNOWN_COLORS.has(color) ? color : ROOT_COLOR}`;

const HUES = {
  indigo: [239, 84],
  sky: [199, 89],
  emerald: [152, 69],
  amber: [38, 92],
  rose: [350, 89],
  violet: [262, 83],
  pink: [322, 81],
  slate: [215, 20],
};

export const SHAPE_FILLS = [{ key: 'plain', label: 'White' }, ...NODE_COLORS];
export const SHAPE_STROKES = [{ key: 'none', label: 'No outline' }, ...NODE_COLORS];
export const DEFAULT_SHAPE_FILL = 'amber';
export const DEFAULT_SHAPE_STROKE = 'amber';

export const isPlainFill = (fill) => !HUES[fill];
export const isNoStroke = (stroke) => !HUES[stroke];

export const hueVars = (fill, stroke) => {
  const [fh, fs] = HUES[fill] ?? HUES.slate;
  const [sh, ss] = HUES[stroke] ?? HUES[fill] ?? HUES.slate;
  return { '--fh': fh, '--fs': `${fs}%`, '--sh': sh, '--ss': `${ss}%` };
};
